export function getRouteParams({ keyName, $route }) {
  const keyNames = Array.isArray(keyName) ? keyName : keyName ? [keyName] : [];
  const routeParams = $route?.params || {};

  const hasKey = !!routeParams[keyNames[0]];

  let keyParams = {};
  keyNames.forEach((key) => {
    routeParams[key] && (keyParams[key] = routeParams[key]);
  });

  return {
    hasKey,
    keyParams
  };
}

export function getRouteFullUrl({ $router, base, name, params, query }) {
  const routeOrigin = window.location.origin;
  params = params || {};
  query = query || {};
  const routeBase =
    base.charAt(base.length - 1) === '/' ? base.slice(0, -1) : base;
  const routePath = $router.resolve({ name, params, query }).route.fullPath;

  return `${routeOrigin}${routeBase}${routePath}`;
}

export function getMatchedRoute({ menu, routeName, subMenuKey }) {
  let menuIndex = -1; // 用于返回顶层menu的index
  let menuItem = {};
  let subMenuItem = {};

  function findMenuItem(menuItems, parentMenuItem = {}) {
    for (let i = 0; i < menuItems.length; i++) {
      const currentMenuItem = menuItems[i];
      if (currentMenuItem.name === routeName) {
        menuItem = parentMenuItem;
        subMenuItem = currentMenuItem;
        return true;
      }
      if (
        currentMenuItem[subMenuKey] &&
        findMenuItem(currentMenuItem[subMenuKey], currentMenuItem)
      ) {
        menuIndex = i; // 记录子菜单中的index
        return true;
      }
    }
    return false;
  }

  findMenuItem(menu);

  return { menuIndex, menuItem, subMenuItem };
}
